import React from "react";
import {
    Row,
    Col,
} from "reactstrap";
import BannerApiComponent from "../../../../../airports/p11v5-nsru-backend/web-services/BannerApiComponent";
import Array from "../../../../../libraries/Array";
import Banner from "../../../../../project-components/parts/Banner";
import WidgetTemplate1 from "../../../../widgets/WidgetTemplate1";

class BannerSection extends React.Component
{
    constructor(props) {
        super(props);
        this.localStorageKey = 'banners-' + this.props.categoryId;

        let apps = []
        if(localStorage.getItem(this.localStorageKey))
        {
            apps = JSON.parse(localStorage.getItem(this.localStorageKey))
        }

        this.state = {
            apps: apps
        }
    }

    componentDidMount() {
        const bannerAPI = new BannerApiComponent();
        bannerAPI.index(this.props.categoryId, res => {
            let ids = Array.pluck(res, 'id');
            localStorage.setItem(this.localStorageKey, JSON.stringify(ids))
            this.setState({
                apps: ids
            })
        })
    }

    render() {
        return (
            <>
                <WidgetTemplate1 title={"Banner"}>
                    <Row noGutters={true}>
                        {this.state.apps.map((bannerId, i) => {
                            //Return the element. Also pass key
                            return (
                                <Col xs="6" md="6" key={i}>
                                    <Banner
                                        id={bannerId}
                                        appTarget={"_self"}
                                        withTail={this.props.tail ?? ""}
                                    />
                                </Col>
                            )
                        })}

                    </Row>
                </WidgetTemplate1>
            </>
        );
    }

}

export default BannerSection;
